import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expense-approval',
  templateUrl: './expense-approval.component.html',
  styleUrls: ['./expense-approval.component.scss']
})
export class ExpenseApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
